import {uuid} from 'uuidv4';
import {VARIABLE} from './types.js';

const SPACE = ' ';
const BRACKET_LEFT = '[';
const BRACKET_RIGHT = ']';
const TILDA = '~';
const STAR = '*';
const MOD = '^';
const FORWARD_SLASH = '/';

const newVar = (name) => ({
    type: VARIABLE,
    name 
});

const newLeaf = () => ({
    cycle: undefined,
    transpose: '',
    operand: '',
    operator: undefined,
    id: uuid()
});

export const parse = (str) => {
    str = ' ' + str + ' ';
    let current = []; // current cycle
    let stack = [current];
    let leaf = newLeaf();
    for (let i=0; i < str.length; i++) {
        let c = str.charAt(i);
        switch (c) {
        case STAR:
            if (leaf.transpose === '') {
                leaf.cycle = current.pop();
            }
            leaf.operator = '*';
            break;
        case MOD:
            if (leaf.transpose === '') {
                leaf.cycle = current.pop();
            }
            leaf.operator = '^';
            break;
        case FORWARD_SLASH:
            if (leaf.transpose === '') {
                leaf.cycle = current.pop();
            }
            leaf.operator = '/';
            break;
        case TILDA:
            leaf.transpose = null;
            break;
        case SPACE:
            completeLeaf(leaf, current);
            leaf = newLeaf();
            break;
        case BRACKET_LEFT:
            completeLeaf(leaf, current);
            current = [];
            stack.push(current);
            leaf = newLeaf();
            break;
        case BRACKET_RIGHT:
            completeLeaf(leaf, current);
            let old = stack.pop();
            current = stack[stack.length - 1] || [];
            current.push(old);
            leaf = newLeaf();
            break;
        default:
            if (leaf.operator) {
                leaf.operand += c;
            } else {
                leaf.transpose += c;
            }
        }
    }
    return stack[0];
};

function lastAdded(stack) {
    return stack[stack.length = 1] || [];

}

function completeLeaf(leaf, current) {
    if (leaf.cycle) {
        if (!isNaN(parseInt(leaf.operand))) {
            leaf.operand = parseInt(leaf.operand);
        } else {
            leaf.operand = newVar(leaf.operand);
        }
        current.push(leaf);
    } else if (leaf.transpose !== undefined && leaf.transpose !== "") {
        let transpose = null;
        if (leaf.transpose != null) {
            transpose = parseFloat(leaf.transpose);
            if (!isNaN(transpose)) {
                // its a number
                leaf.transpose =  transpose;
            } else {
                // it's a variable!
                leaf.transpose = newVar(leaf.transpose);
            }
        }

        if (!isNaN(parseInt(leaf.operand))) {
            leaf.operand = parseInt(leaf.operand);
        } else if (leaf.operand && leaf.operand !== "") {
            leaf.operand = newVar(leaf.operand);
        }
        current.push(leaf);
    }
}

export const getCycleString = (cycle) => {
    let str = "";
    for (let i=0; i < cycle.length; i++) {
        if (Array.isArray(cycle[i])) {
            str += "[" + getCycleString(cycle[i]) + "] ";
        } else {
            str += getLeafString(cycle[i]);
            if (i < cycle.length - 1) {
                str += ' ';
            }
        }
    }
    return str;
}

export const getLeafString = (leaf, skipOperator=false) => {
    if (leaf.cycle) {
        return "[" + getCycleString(leaf.cycle) + "]" + leaf.operator + getOperandString(leaf.operand);
    }
    if (leaf.operator) {
        let leafStr = leaf.transpose;
        if (leafStr == null) {
            leafStr = "~";
        } else if (typeof leaf.transpose === "object") {
            leafStr = leaf.transpose.name;
        } else {
            leafStr = leaf.transpose;
        }
        let x = skipOperator ? leafStr : leafStr + leaf.operator + getOperandString(leaf.operand);
        return x;
    } else if (typeof leaf.transpose === "object") {
        return leaf.transpose === null ? "~" : leaf.transpose.name;
    } else {
        return leaf.transpose;
    }
};

const getOperandString = (x) => {
    if (x === "") {
        return undefined;
    }
    return typeof x === "object" ? x.name : x;
};


